<div id="header" class="conatiner-fluid">
    <div class="row text-center">
        <div class="col-md-4">
            <div class="btn-group">
                <div class="btn btn-primary"
                    mwlCalendarPreviousView
                    [view]="view"
                    [(viewDate)]="viewDate">
                    Previous
                </div>
                <div class="btn btn-outline-secondary"
                    mwlCalendarToday
                    [(viewDate)]="viewDate">
                    Today
                </div>
                <div class="btn btn-primary"
                    mwlCalendarNextView
                    [view]="view"
                    [(viewDate)]="viewDate">
                    Next
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <h3>{{ viewDate | calendarDate: (view + 'ViewTitle') : locale : weekStartsOn }}</h3>
        </div>
    </div>
</div>

<div class="container-fluid">
    <mwl-calendar-week-view
        [viewDate]="viewDate"
        [events]="events"
        [locale]="locale"
        [weekStartsOn]="weekStartsOn"
        [weekendDays]="weekendDays"
        [dayStartHour]="9"
        [dayEndHour]="22"
    >
    </mwl-calendar-week-view>
</div>